<template>
  <v-btn
    outlined
    color="gray0"
    class="rounded-0"
    id="pdfBtn"
    height="4vh"
    @mousedown="downloadFile"
  >
    pdf
  </v-btn>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  props: ["dom", "name"],
  methods: {
    downloadFile() {
      const me = this;
      const file = document.querySelector(me.dom);
      const elementToRemove = document.querySelector(".menu-to-print");
      if (elementToRemove) {
        elementToRemove.parentNode.removeChild(elementToRemove);
      }
      const buttonToRemove = file.querySelector(".top-button");
      if (buttonToRemove) {
        buttonToRemove.parentNode.removeChild(buttonToRemove);
      }

      const rows = file.querySelectorAll("tr");
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        const lastCell = row.lastElementChild;
        if (lastCell) {
          row.removeChild(lastCell);
        }
      }

      var opt = {
        margin: 1,
        filename: me.name,
      };
      html2pdf().from(file).set(opt).save();
      // this.$router.push({
      //   path: `${window.location.pathname}`,
      //   query: { type: 2 },
      // });
      setTimeout(() => {
        this.reloadComponent();
      }, 600);
    },
    reloadComponent() {
      window.location.replace(window.location.pathname);
    },
  },
};
</script>
